/**
 * @file    useFetchTriggers
 * @scope   SHARED
 * @summary Re-fetches when the selected dropdown values or the chart view change.
 * @consumes WidgetContext
 * @produces Nothing.
 * @sideEffects Calls getData; flips the first-render guard after a dropdown selection.
 */
import { MutableRefObject, useEffect } from 'react';
import { useWidgetContext } from 'contexts/WidgetProvider';

export const useFetchTriggers = (
  getData: (page: number) => Promise<void>,
  firstRender: MutableRefObject<boolean>
) => {
  const { chartView, selectedValueL1, selectedValueL2 } = useWidgetContext();

  useEffect(() => {
    if (
      (selectedValueL1 && selectedValueL1?.label !== '') ||
      (selectedValueL2 && selectedValueL2?.label !== '')
    ) {
      // WHY: getData runs before the guard flips, so the mount-time selection never fetches.
      getData(1);
      firstRender.current = false;
    }
  }, [selectedValueL1, selectedValueL2]);

  useEffect(() => {
    getData(1);
  }, [chartView]);
};
